import { Api } from '../lib/api/api';
import { toast } from 'react-toastify';

export const getProposalByKey = (uuid) => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'GET_PROPOSAL_BY_KEY',
    uuid
  });
  try {
    const proposal = await api.proposals.getProposalByKey(uuid);
    dispatch({
      type: 'GET_PROPOSAL_BY_KEY_SUCCESS',
      proposal,
    });
    return proposal;
  } catch (err) {
    dispatch({
      type: 'GET_PROPOSAL_BY_KEY_ERROR',
      err,
    });
  }
};

export const updateProposalSigned = (uuid, proposalMeta) => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'UPDATE_PROPOSAL_BY_KEY',
  });
  try {
    const signedProposal = await api.proposals.updateProposalSigned(uuid, proposalMeta);
    dispatch({
      type: 'UPDATE_PROPOSAL_BY_KEY_SUCCESS',
    });
    toast.success('Thanks for accepting the offer!', { toastId: 'UPDATE_PROPOSAL_BY_KEY_SUCCESS' });
    return signedProposal;
  } catch (err) {
    dispatch({
      type: 'UPDATE_PROPOSAL_BY_KEY_ERROR',
      err,
    });
  }
};

export const proposalSignFieldUpdate = (name, value) => dispatch => {
  dispatch({
    type: 'PROPOSAL_SIGN_FIELD_UPDATE',
    name,
    value,
  });
};

export const getLogoByCompany = (token, cid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_PROPOSAL_LOGO'
  });

  try {
    const img = await api.proposals.getLogoByCompany(cid);
    dispatch({
      type: 'GET_PROPOSAL_LOGO_SUCCESS',
    });
    return img;
  } catch (error) {
    dispatch({
      type: 'GET_PROPOSAL_LOGO_ERROR',
      error,
    });
  }
}
